import { VendorBookingStatus } from '../types/Vendor';

// Canonical label/color for the 8-value booking_status vocabulary shared by
// VendorBooking.status and VendorBudgetItem.booking_status. Single source so
// VendorTable's directory view and BudgetTracker's category Vendors tab
// never drift into showing different words for the same status again.
export const VENDOR_BOOKING_STATUS_LABELS: Record<VendorBookingStatus, string> = {
  inquiry: 'Inquiry',
  quoted: 'Quoted',
  negotiating: 'Negotiating',
  booked: 'Booked',
  'contract-signed': 'Contract Signed',
  'paid-in-full': 'Paid in Full',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
};

export const VENDOR_BOOKING_STATUS_COLORS: Record<VendorBookingStatus, string> = {
  inquiry: '#64748b',
  quoted: '#2563eb',
  negotiating: '#d97706',
  booked: '#16a34a',
  'contract-signed': '#7c3aed',
  'paid-in-full': '#059669',
  rejected: '#dc2626',
  cancelled: '#dc2626',
};
